import React from 'react'
import {
  CampaignTemplateChannel,
  ICampaignTemplate,
} from '@dataTypes/marketing.type'
import { emailCanvasCssVars } from '@utils/marketingTemplate.util'
import { sanitizeEmailHtml } from '@utils/sanitize-html.util'

interface TemplateItemPreviewProps {
  template: ICampaignTemplate
}

function smsContentLength(template: ICampaignTemplate): number {
  return (
    template.text_content.replace('\n\n', '').length +
    (template.text_content.match(/\n\n/g) || []).length
  )
}

const TemplateItemPreview: React.FC<TemplateItemPreviewProps> = ({
  template,
}) => {
  if (template.channel === CampaignTemplateChannel.email) {
    return (
      <div
        className="mt-template-item-preview mt-template-item-preview--email"
        style={emailCanvasCssVars(template.email_editor_canvas)}
      >
        <div
          className="mt-template-item-preview-email-inner mt-marketing-email-tpl-root"
          style={emailCanvasCssVars(template.email_editor_canvas)}
          dangerouslySetInnerHTML={{
            __html: sanitizeEmailHtml(template.html_content),
          }}
        />
      </div>
    )
  }

  const length = smsContentLength(template)
  return (
    <div className="mt-template-item-preview">
      <div
        className={`mt-template-item-preview-image${length >= 183 ? ' long' : ''}`}
        dangerouslySetInnerHTML={{
          __html: sanitizeEmailHtml(template.html_content),
        }}
      />
    </div>
  )
}

export default TemplateItemPreview
